import { createRequest } from 'ducks/helpers';
import constants from './constants';

export const switchAppType = createRequest(constants.dev);

export const switchApp = switchAppType;
